/* ============================================================
   NuBuro [NB] PLP behaviors — promo dismiss + countdown, FAQ accordion.
   Self-initializing and idempotent so it survives Shopify theme-editor
   section re-renders. No dependency on the design prototype's Tweak panel.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- Promo bar ---------- */
  function initPromo(root) {
    var bar = root.querySelector("[data-nb-promo]");
    if (!bar || bar.__nbInit) return;
    bar.__nbInit = true;

    var key = "nb-promo-dismissed:" + (bar.dataset.nbPromoId || "default");

    if (bar.dataset.nbDismissible === "true") {
      try {
        if (window.localStorage.getItem(key) === "1") {
          bar.hidden = true;
        }
      } catch (e) {}
      var btn = bar.querySelector(".pdismiss");
      if (btn) {
        btn.addEventListener("click", function () {
          bar.hidden = true;
          try {
            window.localStorage.setItem(key, "1");
          } catch (e) {}
        });
      }
    }

    var countEl = bar.querySelector("[data-nb-countdown]");
    if (countEl) {
      var deadline = Date.parse(countEl.getAttribute("data-nb-countdown"));
      if (!isNaN(deadline)) {
        var tick = function () {
          var diff = deadline - Date.now();
          if (diff <= 0) {
            countEl.textContent = "";
            clearInterval(timer);
            return;
          }
          var totalMinutes = Math.floor(diff / 60000);
          var d = Math.floor(totalMinutes / 1440);
          var h = Math.floor((totalMinutes % 1440) / 60);
          var m = totalMinutes % 60;
          var s = Math.floor((diff % 60000) / 1000);
          var pad = function (n) {
            return n < 10 ? "0" + n : "" + n;
          };
          countEl.textContent =
            (d > 0 ? d + "d " : "") + pad(h) + ":" + pad(m) + ":" + pad(s);
        };
        tick();
        var timer = setInterval(tick, 1000);
      }
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initAccordions(root) {
    root.querySelectorAll("[data-nb-acc]").forEach(function (acc) {
      if (acc.__nbInit) return;
      acc.__nbInit = true;
      acc.addEventListener("click", function (e) {
        var q = e.target.closest(".nb-acc-q");
        if (!q || !acc.contains(q)) return;
        var item = q.closest(".nb-acc-item");
        if (item) item.classList.toggle("open");
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initPromo(root);
    initAccordions(root);
  }

  if (document.readyState !== "loading") {
    initAll(document);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  }

  /* Shopify theme editor: re-init when a section is loaded/reordered. */
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
